import { useQuery } from 'libs/query'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { AuthContext } from 'store'
import { IBookingInfo } from '../types'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'

export const useFetchBookings = (query: string) => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)

	const fetchBookings = () => axiosPrivate.get(apiRoutes.bookingsCalendar(query))

	const { data: bookings } = useQuery<{ data: IBookingInfo[] }>({
		queryKey: queryKeys.bookings.calandar(query),
		queryFn: fetchBookings,
		enabled: !!auth.accessToken
	})

	return {
		bookings
	}
}
